import styles from './authorization.module.css';

export function DomainScopeCards({
  domains,
  domain,
}: {
  domains: readonly string[];
  domain: string;
}) {
  const ordered = [...new Set(domains)].sort((a, b) => {
    if (a === domain) return -1;
    if (b === domain) return 1;
    if (a.startsWith('*.') !== b.startsWith('*.')) return a.startsWith('*.') ? 1 : -1;
    return a.localeCompare(b);
  });

  return (
    <ul className={styles.scopeCards} aria-label="Included domain scope">
      {ordered.map((host) => (
        <li className={styles.scopeCard} key={host}>
          <code>{host}</code>
          <span>
            {host.startsWith('*.')
              ? 'All subdomains at any depth; base domain excluded'
              : host === domain
                ? 'Base domain only'
                : 'Exact host'}
          </span>
        </li>
      ))}
    </ul>
  );
}
